module.exports = __webpack_public_path__ + "static/img/equipment1new.9df57db9.png";